import * as React from 'react';
import { editDealroomFinStr ,deleteFinStrFromDealroom} from '../../../../store/actions';
import {connect} from 'react-redux';
import {preCreatingEditValues} from "./helpers";
import {validationCheck} from "../../../helpers";

class CustomIconsAgGrid extends React.Component {


  onEdit = (id) => {
    const {params, dealroomFinSchemaErrors, editDealroomFinStr} = this.props;
    const {data, colDef} = params;
    const result = preCreatingEditValues(data, colDef.financial_structure);

    if (!validationCheck(dealroomFinSchemaErrors[colDef.finStrIndex])) {
      editDealroomFinStr(result, id);
    }
  };

  onDelete = (id) => {
    const {deleteFinStrFromDealroom,params} = this.props;
    const {removeChoosenProjects} = params.agGridReact.props;

    deleteFinStrFromDealroom(id);
    removeChoosenProjects('onFinStrcheckbox',-1)

  };

  render() {
    const {params} = this.props;
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start'
      }}>
        <ul className="list-actions">
          <li>
            <i
                className="btn-delete fa fa-trash fa-lg "
                onClick={() => this.onDelete(params.id)}
            />
          </li>
          <li>
            <i
                className="btn-edit fa fa-pencil fa-lg"
                onClick={() => this.onEdit(params.id)}
            />
          </li>
        </ul>
        <p style={{
          height: '29px',
          marginLeft: '10px'
        }}>{params.name}</p>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    dealroomFinSchemaErrors: state.financicalSchemas.dealroomFinSchemaErrors,
  }
};

export default connect(mapStateToProps, {
  editDealroomFinStr,
  deleteFinStrFromDealroom

})(CustomIconsAgGrid);



// WEBPACK FOOTER //
// ./src/views/Dealroom/Dealroom/DealroomFinStr/CustomIconsAgGrid.js